import React from 'react';
import PropTypes from 'prop-types';

const styles = {
	links: { color: '#284263' },
}

const CHBoolField = ({ source, source_disp, record = {} }) => (record[source] === true ? 'Ja' : 'Nee');

CHBoolField.propTypes = {
    label: PropTypes.string,
    record: PropTypes.object,
    source: PropTypes.string.isRequired,
};

export default CHBoolField;


// WEBPACK FOOTER //
// ./src/utils/CHBoolField.js